import { useEffect, useRef } from "react";
import './pages.css';


const AdminSurveyManagePageLeft = ({
    surveys,
    selectedSurveyId,
    selectSurvey,
    newSurvey,
    setNewSurvey,
    createSurvey,
    updateSurvey,
    deleteSurvey,
    allSites,
    programs, selectedProgram, setSelectedProgram
    }) => {
    // 컴포넌트 내부
    const itemRefs = useRef({});
    const filteredSites = selectedProgram
    ? allSites.filter(s => String(s.program_id) === String(selectedProgram))
    : allSites;
        
    // 2) 설문 목록 필터: (1) 사업 → (2) 사이트(newSurvey.site_id)
    const selectedSiteId = newSurvey?.site_id ? String(newSurvey.site_id) : '';
    const siteIdSet = new Set(filteredSites.map(s => String(s.site_id)));

    let filteredSurveys = surveys;
    // 사업이 선택되어 있으면, 그 사업에 포함된 사이트들의 설문만
    if (selectedProgram) {
    filteredSurveys = filteredSurveys.filter(s => siteIdSet.has(String(s.site_id)));
    }
    // 사이트가 선택되어 있으면, 그 사이트 설문만
    if (selectedSiteId) {
    filteredSurveys = filteredSurveys.filter(s => String(s.site_id) === selectedSiteId);
    }

    useEffect(() => {
        const el = itemRefs.current?.[selectedSurveyId];
        if (el) el.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }, [selectedSurveyId]);

    return (
        <div className="admin-left-section">
        <h2 className="center-title">설문조사 관리 페이지</h2>

        <div className="bg-gray-100 p-4 rounded mb-6">
            <h3>📋 설문 추가하기</h3>

            {/* ✅ 사업 선택 */}
            <select
                value={selectedProgram}
                onChange={(e) => {
                    setSelectedProgram(e.target.value);
                    // 사업 바뀌면 사이트 선택 초기화 (필터도 함께 초기화)
                    setNewSurvey(prev => ({ ...prev, site_id: '' }));
                }}
                className="input-beauty"
                style={{ marginBottom: 8 }}
            >
            <option value="">📦 사업 선택 (전체)</option>
                {programs.map(p=>(
                <option key={p.program_id} value={p.program_id}>
                    {p.name}{p.year ? ` (${p.year})` : ''}
                </option>
                ))}
            </select>

                   {/* ✅ 사이트 선택 드롭다운 추가 */}
            <select
            value={newSurvey.site_id || ''}
            onChange={(e) => {
                const v = e.target.value;
                setNewSurvey(prev => ({
                ...prev,
                site_id: v ? parseInt(v, 10) : ''   // '' = 전체
                }));
            }}
            className="input-beauty"
            style={{ marginBottom: 8 }}
            >
            <option value="">📍 사이트 선택</option>
            {filteredSites.map((site) => (
                <option key={site.site_id} value={site.site_id}>
                {site.site_name}
                </option>
            ))}
            </select>


            <input
            type="text"
            placeholder="설문 제목"
            value={newSurvey.title}
            onChange={(e) => setNewSurvey({ ...newSurvey, title: e.target.value })}
            className="input-beauty"
            />
            <textarea
            placeholder="설문 설명"
            value={newSurvey.description}
            onChange={(e) => setNewSurvey({ ...newSurvey, description: e.target.value })}
            className="input-beauty"
            />
            <button onClick={createSurvey} className="detail-add-button">
            등록
            </button>
        </div>
        
            <h3>📁 설문 목록</h3>
            <ul className="survey-title-list">
            {filteredSurveys.map((survey) => {
                const isActive = String(survey.survey_id) === String(selectedSurveyId);
                return (
                <li
                    key={survey.survey_id}
                    ref={(el) => (itemRefs.current[survey.survey_id] = el)}
                    onClick={() => selectSurvey(survey.survey_id)}
                    className={`survey-item ${isActive ? "is-active" : ""}`}
                    aria-selected={isActive}
                >
                    <div className="survey-header">
                    <div className="survey-title">{survey.title}</div>
                    <div className="edit-delete-icon-group">
                    <button
                        className="edit-delete"
                        onClick={(e) => {
                        e.stopPropagation();
                        const newTitle = prompt('새 제목을 입력하세요', survey.title);
                        const newDesc = prompt('새 설명을 입력하세요', survey.description);
                        if (newTitle && newDesc) {
                            updateSurvey(survey.survey_id, {
                            title: newTitle,
                            description: newDesc
                            });
                        }
                        }}
                    >
                        수정✏️
                    </button>
                    <button
                        className="edit-delete"
                        onClick={(e) => {
                        e.stopPropagation();
                        deleteSurvey(survey.survey_id);
                        }}
                    >
                        삭제🗑
                    </button>
                    </div>
                    </div>
                    <div className="survey-description">{survey.description}</div>
                </li>
                );
            })}
</ul>
        </div>
    );
    };

export default AdminSurveyManagePageLeft;
